import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { DepartmentInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { DepartmentDetailSaveModel } from '../models/department-detail-save.model';
import { deleteDepartmentMutation } from '../queries/delete-department.graphql';
import { DeleteDepartmentVariables } from '../queries/generated/DeleteDepartment';
import { SaveDepartment, SaveDepartmentVariables } from '../queries/generated/SaveDepartment';
import { SaveDepartmentMutation } from '../queries/save-department.graphql';

@Injectable({ providedIn: 'root' })
export class DepartmentDetailApiService {
   constructor(private apiService: LcsApiService, private httpClient: HttpClient) {}

   save(
      departmentDetail: DepartmentDetailSaveModel,
      fields: (keyof DepartmentInput)[]
   ): Observable<ExecutionResult<SaveDepartment>> {
      const department = { ...departmentDetail, fields } as DepartmentInput;

      const variables: SaveDepartmentVariables = {
         department: department,
      };
      return this.apiService.query<SaveDepartment, SaveDepartmentVariables>({
         query: SaveDepartmentMutation,
         variables: variables,
      });
   }

   deleteDepartment(departmentId: number): Observable<ExecutionResult<void>> {
      return this.apiService.query<void, DeleteDepartmentVariables>({
         query: deleteDepartmentMutation,
         variables: {
            departmentId,
         },
      });
   }

   mergeDepartments(sourceDepartmentId: number, destinationDepartmentId: number) {
      const params = new HttpParams()
         .set('sourceDepartmentId', sourceDepartmentId.toString())
         .set('destinationDepartmentId', destinationDepartmentId.toString());
      return this.httpClient.post<void>(this.apiService.apiUrl + '/Departments/MergeDepartments', null, {
         params,
         observe: 'response',
      });
   }

   untagDepartment(departmentId: number) {
      const url = `${this.apiService.apiUrl}/Departments/Clear/${departmentId}`;
      return this.httpClient.post<void>(url, null, {
         observe: 'response',
      });
   }
}
